/** Body attribute set while the add_remove tip is active; the toolbar reads it. */
export const DEMO_TIP_ATTR = 'data-demo-tip';

/**
 * sx for the toolbar buttons the add_remove tip points at: a slow outline
 * pulse (2 pulses) while the tip is active, a static outline when the visitor
 * prefers reduced motion.
 */
export const demoTipHighlightSx = {
  [`body[${DEMO_TIP_ATTR}="add_remove"] &`]: {
    outline: '2px solid',
    outlineColor: 'primary.main',
    outlineOffset: 2,
    '@media (prefers-reduced-motion: no-preference)': {
      animation: 'demoTipPulse 1.2s ease-in-out 2',
    },
  },
  '@keyframes demoTipPulse': {
    '0%, 100%': { outlineOffset: 2, outlineColor: 'transparent' },
    '50%': { outlineOffset: 5, outlineColor: 'currentColor' },
  },
};
